/**
 * The default lock manager used in non-browser environments.
 * It implements a subset of Web Locks API that we depend on for a single Javascript process. */
export class SingleProcessLockManager {
    locks = new Map();
    async request(name, callback) {
        const lock = this.locks.get(name);
        if (lock) {
            await lock;
        }
        const taskPromise = callback();
        this.locks.set(name, Promise.resolve(taskPromise).catch(() => undefined));
        try {
            return await taskPromise;
        }
        finally {
            this.locks.delete(name);
        }
    }
}
export const locks = typeof navigator === 'object' && navigator.locks
    ? navigator.locks
    : new SingleProcessLockManager();
